import React from "react";
import { Star, Sparkles } from "lucide-react";
import BirthForm from "../components/BirthForm";
import SEO from "../components/SEO";

/**
 * KundliFormPage — dedicated page reached via the navbar/bottom-tab "Kundli" button.
 * Always shows the birth-details form so users can generate a fresh chart.
 */
export default function KundliFormPage() {
  return (
    <div style={{ minHeight: "100vh", background: "#120021", paddingTop: "90px", paddingBottom: "60px", position: "relative" }}>
      <SEO
        title="Free Vedic Kundli Generator — AstroFate"
        description="Generate your free Vedic birth chart (Kundli) instantly. Enter your DOB, time and birth city — get planetary positions, dashas, yogas, and AI predictions in under a minute."
      />
      <div style={{ position: "fixed", inset: 0, pointerEvents: "none", zIndex: 0 }}>
        <div style={{ position: "absolute", width: "640px", height: "640px", background: "radial-gradient(circle, rgba(91,30,140,0.25), transparent)", top: "-120px", right: "-200px", borderRadius: "50%" }} />
        <div style={{ position: "absolute", width: "500px", height: "500px", background: "radial-gradient(circle, rgba(45,11,69,0.4), transparent)", bottom: "-100px", left: "-150px", borderRadius: "50%" }} />
      </div>

      <div style={{ maxWidth: "560px", margin: "0 auto", padding: "0 16px", position: "relative", zIndex: 1 }}>
        <div className="animate-fadeInUp" style={{ textAlign: "center", marginBottom: "28px" }}>
          <div style={{ display: "inline-flex", alignItems: "center", gap: "8px", background: "rgba(255,209,102,0.08)", border: "1px solid rgba(255,209,102,0.2)", borderRadius: "50px", padding: "6px 16px", marginBottom: "16px" }}>
            <Star size={13} style={{ color: "#FFD166" }} fill="#FFD166" />
            <span style={{ color: "#FFD166", fontSize: "0.76rem", fontWeight: "600" }}>Vedic AI Astrology</span>
          </div>
          <h1 className="font-cinzel gradient-text-gold" style={{ fontSize: "clamp(1.6rem, 4vw, 2.4rem)", marginBottom: "8px" }}>
            Generate Your Kundli
          </h1>
          <p style={{ color: "rgba(255,255,255,0.55)", fontSize: "0.92rem", lineHeight: 1.6, maxWidth: "440px", margin: "0 auto" }}>
            Enter your accurate birth details and we&apos;ll calculate your Vedic chart, dashas, yogas, and predictions instantly.
          </p>
        </div>

        <div className="animate-fadeInUp delay-100">
          <BirthForm compact />
        </div>

        <p style={{ textAlign: "center", color: "rgba(255,255,255,0.4)", fontSize: "0.78rem", marginTop: "20px", lineHeight: 1.6 }}>
          <Sparkles size={11} style={{ display: "inline", marginRight: "4px", color: "#FFD166" }} />
          Your data stays on your device for this session — no signup required.
        </p>
      </div>
    </div>
  );
}
